import { render, staticRenderFns } from "./DeviceSettingsList.vue?vue&type=template&id=335a4a1a&"
import script from "./DeviceSettingsList.vue?vue&type=script&lang=js&"
export * from "./DeviceSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSettingsList.vue?vue&type=style&index=0&id=335a4a1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports